import { render, staticRenderFns } from "./AssignRolePermission.vue?vue&type=template&id=2fae3ed6&"
import script from "./AssignRolePermission.vue?vue&type=script&lang=js&"
export * from "./AssignRolePermission.vue?vue&type=script&lang=js&"
import style0 from "./AssignRolePermission.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports